/* eslint-disable */
// import User from "../services/interfaces/User";

declare global {
  interface Window {
    AleaControlShell: any;
  }
}

const AleaControlShell = {
  setCoinAcceptorEvent: function (fun: (t: any) => void) {
    window.AleaControlShell.setCoinAcceptorEvent(fun);
  },
  addCoin: function (t: any) {
    window.AleaControlShell.addCoin(t);
  },
  setBarcodeScannerAcceptorEvent: function (
    fun: (
      type: string,
      barcode: string,
      operator: string,
      player: string
    ) => void
  ) {
    window.AleaControlShell.setBarcodeScannerAcceptorEvent(fun);
  },
  barcodeScannerRead: function (t: any, n: any, e: any, r: any) {
    window.AleaControlShell.barcodeScannerRead(t, n, e, r);
  },
  setCopyLastTicketEvent: function (fun: () => void) {
    window.AleaControlShell.setCopyLastTicketEvent(fun);
  },
  copyLastTicket: function () {
    window.AleaControlShell.copyLastTicket();
  },
  setPrintLastJackpotsEvent: function (fun: () => void) {
    window.AleaControlShell.setPrintLastJackpotsEvent(fun);
  },
  printLastJackpots: function () {
    window.AleaControlShell.printLastJackpots();
  },
  setLoyaltyCardScannerAcceptorEvent: function (fun: (t: any) => void) {
    window.AleaControlShell.setLoyaltyCardScannerAcceptorEvent(fun);
  },
  loyaltyCardRead: function (t: any) {
    window.AleaControlShell.loyaltyCardRead(t);
  },
  setChangeLanguageEvent: function (fun: (lang: string) => void) {
    window.AleaControlShell.setChangeLanguageEvent(fun);
  },
  changeLanguage: function (lang: string) {
    window.AleaControlShell.changeLanguage(lang);
  },
  setChangeTabEvent: function (fun: (t: any) => void) {
    window.AleaControlShell.setChangeTabEvent(fun);
  },
  changeTab: function (t: any) {
    window.AleaControlShell.changeTab(t);
  },
  setPrintCopyTicketEvent: function (fun: (t: any) => void) {
    window.AleaControlShell.setPrintCopyTicketEvent(fun);
  },
  printCopyTicket: function (t: any) {
    window.AleaControlShell.printCopyTicket(t);
  },
  setPrintText: function (ticketJsonData: any, type: any) {
    return window.AleaControlShell.setPrintText(ticketJsonData, type);
  },
  refreshBalance: function () {
    return window.AleaControlShell.refreshBalance();
  },
  reconnectGame: function (t: any, n: any) {
    return window.AleaControlShell.reconnectGame(t, n);
  },
  getBalance: function () {
    return window.AleaControlShell.getBalance();
  },
  getCurrentOperator: function () {
    return window.AleaControlShell.getCurrentOperator();
  },
  getInsertTicketInformations: function () {
    return window.AleaControlShell.getInsertTicketInformations();
  },
  openCopyTicketWindow: function () {
    return window.AleaControlShell.openCopyTicketWindow();
  },
  openPlayerDetailsForm: function (t: any) {
    return window.AleaControlShell.openPlayerDetailsForm(t);
  },
  sendPresentationEvent: function (gameName: string, data: any) {
    return window.AleaControlShell.sendPresentationEvent(gameName, data);
  },
  setPublishPresentationEvent: function (fun: (data: any) => void) {
    return window.AleaControlShell.setPublishPresentationEvent(fun);
  },
  publishPresentationEvent: function (data: any) {
    return window.AleaControlShell.publishPresentationEvent(data);
  },
  getDeviceToken: function () {
    return window.AleaControlShell.getDeviceToken();
  },
  getDeviceIdentification: function () {
    return window.AleaControlShell.getDeviceIdentification();
  },
};

export default AleaControlShell;
